module.exports = __webpack_public_path__ + "static/media/logo.b786f809.png";